import type { GetRequiredInfoResponse } from './types';

import { getGenericEndpoint } from './get.api';

export const getRequiredInfo = async (lang?: string) => {
	return await getGenericEndpoint<GetRequiredInfoResponse>('signin/required-info', lang);
};
